import React, { useState, useEffect } from 'react';
import Icon from '../../../Icon';
import blackArrowDown from '../assets/black-arrow-down.svg';

import styles from './FilterDropdownSelector.module.css';

const FilterDropdonSelector = props => {
  const { availableClients, alreadySelectedClients, onSelectCompleted } = props;

  const [selectedClients, setSelectedClients] = useState(
    alreadySelectedClients || []
  );
  const [showPopup, setShowPopup] = useState(false);
  const [visibleClients, setVisibleClients] = useState(availableClients);
  const [inputSearch, setInputSearch] = useState('');

  useEffect(
    () => {
      setSelectedClients(alreadySelectedClients || []);
    },
    [alreadySelectedClients]
  );

  const onInputSearch = input => {
    setVisibleClients(
      availableClients.filter(client => client.label.includes(input))
    );
  };

  const isClientSelected = (clientsList, client) => {
    if (client && client.value && clientsList && clientsList.length) {
      const clientAccount = clientsList.filter(
        selectedClient => selectedClient.value === client.value
      );

      if (clientAccount && clientAccount.length) return true;
    }
    return false;
  };

  const findClientIndexInSelected = clientId =>
    selectedClients.findIndex(client => client.value === clientId);

  const selectedClientsLabel = list => {
    if (!list || !list.length) {
      return 'Choose a client account';
    }

    if (list.length === 1) {
      return list[0].label;
    }

    if (list.length > 1) {
      return `${list.length} client account selected`;
    }

    return null;
  };

  return (
    <div className={styles.filterDropdownSelectorContainer}>
      <div
        role="presentation"
        className={styles.selectedClientsLabel}
        style={{ backgroundImage: `url(${blackArrowDown})` }}
        onClick={() => setShowPopup(!showPopup)}
      >
        {selectedClientsLabel(selectedClients)}
      </div>
      {showPopup ? (
        <div className={styles.filterDropdownPopup}>
          <div className={styles.filterDropdownPopupSearchInputContainer}>
            <input
              onChange={e => {
                setInputSearch(e.target.value);
                onInputSearch(e.target.value);
              }}
              placeholder="Search..."
              value={inputSearch}
              /* eslint-disable */
              autoFocus
              /* eslint-enable */
            />
          </div>
          <div className={styles.filterDropdownPopupItemsContainer}>
            {visibleClients && visibleClients.length ? (
              visibleClients.map((client, index) => (
                <div
                  className={styles.filterDropdownItem}
                  key={`filter-dropdown-item-${index.toString()}`}
                  role="presentation"
                  onClick={() => {
                    let newSelectedClients = selectedClients;

                    if (isClientSelected(selectedClients, client)) {
                      const clientIndex = findClientIndexInSelected(
                        client.value
                      );
                      newSelectedClients.splice(clientIndex, 1);
                    } else {
                      newSelectedClients = [...selectedClients, ...[client]];
                    }
                    setSelectedClients(
                      JSON.parse(JSON.stringify(newSelectedClients))
                    );
                  }}
                >
                  <span
                    className={`${
                      isClientSelected(selectedClients, client)
                        ? styles.filterDropdownItemCheckboxSelected
                        : styles.filterDropdownItemCheckbox
                    } check-icon`}
                  >
                    <Icon
                      type={
                        isClientSelected(selectedClients, client)
                          ? 'checked'
                          : 'unchecked'
                      }
                    />
                  </span>
                  <div className={styles.filterDropdownItemLabel}>
                    {client.label}
                  </div>
                </div>
              ))
            ) : (
              <div className={styles.noAvailableClientAccounts}>
                No available client accounts
              </div>
            )}
          </div>
          <div className={styles.filterDropdownPopupFooterContainer}>
            <div
              className={styles.filterDropdownPopupConfirm}
              role="presentation"
              onClick={() => {
                onSelectCompleted(selectedClients);
                setShowPopup(false);
                setInputSearch('');
                setVisibleClients(availableClients);
              }}
            >
              {selectedClients.length ? 'Done' : 'Close'}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default FilterDropdonSelector;
